import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

interface ReportMetadata { 
  name : string,
  uploadedDate : string,
  size : string
}
@Component({
  selector: 'patient-reports-uploaded',
  imports: [CommonModule, FormsModule],
  templateUrl: './reports-uploaded.component.html',
  styleUrl: './reports-uploaded.component.scss'
})
export class ReportsUploadedComponent {
 @Input() reports: ReportMetadata[] = [];
}
